import { Dispatch, SetStateAction, useEffect } from 'react';

import { ICartEntry } from 'features/cart/types';

import { useRefreshOffers } from 'hooks/loyalty/use-refresh-offers';

import type { CartState } from '../types';
import { hasOffers } from '../utils';

import { useCartLiveValidation } from './use-cart-live-validation';

type UseCartInitParams = {
  cartEntries: ICartEntry[];
  setCartState: Dispatch<SetStateAction<CartState>>;
};

export const useCartInit = ({ cartEntries, setCartState }: UseCartInitParams) => {
  useRefreshOffers({ skip: !hasOffers(cartEntries) });
  const { validateCartNow, requestCartValidation } = useCartLiveValidation({ cartEntries });

  useEffect(() => {
    setCartState(prev => {
      if (
        prev.validateCartNow === validateCartNow &&
        prev.requestCartValidation === requestCartValidation
      ) {
        return prev;
      }
      return {
        ...prev,
        validateCartNow,
        requestCartValidation,
      };
    });
  }, [requestCartValidation, setCartState, validateCartNow]);
};
